module.exports = __webpack_public_path__ + "src/img/label.4156a0d2.svg";